module.exports = __webpack_public_path__ + "img/fullBody.a8b8014a.svg";